import React, { useEffect, useState } from 'react';
import usePortalAuth from '../../../auth/usePortalAuth';

import { Button, Form, Input, Label, Row, Col, Modal, ModalHeader, ModalBody } from 'reactstrap';
import classnames from 'classnames';
import { createTheme, MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useForm from '../CustomHooks/useForm';
import Error from '../Error/Error';

const DownloadCheckModal = (props) => {
  const [modal, setModal] = useState(true);
  const toggle = () => {
    setModal(!modal);
  };

  const toggleClose = () => {
    setModal(!modal);
  };

  const [installStatus, setInstallStatus] = React.useState();

  const handleChange = (event) => {
    setInstallStatus(event.target.value);
  };

  const onConfirm = (event) => {
    if (installStatus === 'installed') {
      toggleClose();
    } else if (installStatus === 'notInstalled') {
      props.history.push('/Dashboard/InitialDownloads');
    }
  };

  //-----User Modal close button toggle-----//
  const closeBtn = (
    <Button outline color="white" onClick={toggleClose}>
      <FontAwesomeIcon icon={['fas', 'times']} size="lg" />
    </Button>
  );

  return (
    <div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle} close={closeBtn}></ModalHeader>
        <ModalBody>
          <h1 className="userManagementModalLabel">Have you installed PhishCloud?</h1>
          <br></br>
          <Form id="addUserForm">
            <div className="ModalForm">
              <FormGroup style={{ fontSize: '12px', marginLeft: '0px' }}>
                <RadioGroup
                  aria-label="install status"
                  name="installStatusRadioButtons"
                  value={installStatus}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="installed"
                    control={<Radio color="primary" />}
                    label="I have already installed PhishCloud."
                  />
                  <FormControlLabel
                    value="notInstalled"
                    control={<Radio color="primary" />}
                    label="I have not installed PhishCloud. Take me to the install wizard."
                  />
                </RadioGroup>
              </FormGroup>
            </div>

            <div className="addUserButton">
              <Button onClick={() => onConfirm()} size="lg" color="primary" block>
                Confirm
              </Button>{' '}
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};
export default DownloadCheckModal;

//    < FormControlLabel
//control = {< Checkbox color = "primary" checked = { installed } onChange = { handleChange } name = "installed" />}
//label = "I have not installed PhishCloud. Take me to the install wizard."
//    />
//    <FormControlLabel
//        control={<Checkbox color="primary" checked={notInstalled} onChange={handleChange} name="notInstalled" />}
//        label="I have already installed PhishCloud"
//    />
